import * as React from 'react';
import { Price } from '@grandvisionhq/common';

const StickyPriceView = ({ displayPrice , prefix  })=>{
    const { discountedPrice , originalPrice , currency , isCentAmount  } = displayPrice;
    const isDiscount = Boolean(discountedPrice && discountedPrice !== originalPrice);
    const priceValue = discountedPrice !== null && discountedPrice !== void 0 ? discountedPrice : originalPrice;
    const priceType = isDiscount ? 'discount' : 'default';
    return /*#__PURE__*/ React.createElement(Price, {
        value: priceValue,
        currency: currency,
        centAmount: isCentAmount,
        type: priceType,
        prefix: prefix
    });
};

export { StickyPriceView };
//# sourceMappingURL=StickyPriceView.js.map
